import React, { Component } from 'react';
import './style.scss';

class Process extends Component {
  constructor(props) {
    super(props);
    this.state = {
      started: false,
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({started:true});
    }, 10);
  }

  render() {
    const { started } = this.state;
    let startClass = '';
    if (started) {
      startClass = 'process-started'
    }
    return (
      <div className={`form-process-container ${startClass}`}>
        <div className="form-process-text">
          <h2>Processing your trial request...</h2>
          <div className='spinner'>
            <div className='double-bounce1'></div>
            <div className='double-bounce2'></div>
          </div>
        </div>
      </div>
    );
  }
}

export default Process;


// WEBPACK FOOTER //
// src/views/trial/process.js